import Header from "@/components/Header";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Services from "@/components/Services";
import Manifesto from "@/components/Manifesto";
import GainsEnquiry from "@/components/GainsEnquiry";
import DynoResults from "@/components/DynoResults";
import Testimonials from "@/components/Testimonials";
import SeoLinkTree from "@/components/SeoLinkTree";
import Faq from "@/components/Faq";
import BookingForm from "@/components/BookingForm";
import Footer from "@/components/Footer";
import { useCanonical } from "@/hooks/useCanonical";

export default function HomePage() {
  useCanonical("/");
  return (
    <main className="bg-carbon text-white" data-testid="home-page">
      <Header />
      <Hero />
      <EditorialMarquee />
      <Services />
      <Manifesto />
      <GainsEnquiry />
      <DynoResults />
      <Testimonials />
      <SeoLinkTree />
      <Faq />
      <BookingForm />
      <Footer />
    </main>
  );
}
